import { put, call, all, takeLatest } from 'redux-saga/effects';
import { merge, get, clone, set } from 'lodash';
import { ACITONCOPYRIGHT } from '../../../actionTypes';
import { APIUSER, APICOMMON, APICOPYRIGHT } from '../../../actionApi';
import { request } from '../../../utils/request';
import { API } from '../../../env';
import { readCookie } from '../../../utils/common';
function* uploadImgInfo(data) {
	let { payload, callback, errorCallback } = data;
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.UPLOADIMGINFO,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		// yield put({ type: ACITONCOPYRIGHT.SET_ACTIVITY_CONTENT, payload: result });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
/**
 * UPPY AWS S3
 * GETTOKEN
 */
function* getUploadToken(data) {
	let { payload, callback, errorCallback } = data;
	let token = readCookie('userToken') || '';
	let res = yield call(request, {
		type: 'POST',
		url: API.COMMON_PORXY + APICOPYRIGHT.UPLOADTOKEN + '?&ossType=2&token=' + token,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('uploadToken...', res);
		yield put({ type: ACITONCOPYRIGHT.SET_UPLOAD_TOKENINFO, payload: result.data });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}
function* getRedisKey(data) {
	let { payload={}, callback, errorCallback } = data;
	let token = readCookie('userToken') || '';
	// payload.ossType=2;
	let res = yield call(request, {
		type: 'POST',
		contentType: 'application/x-www-form-urlencoded',
		url: API.COMMON_PORXY + APICOPYRIGHT.GETUPLOADREDISKEY,
		dataParam: payload || {}
	});
	let { ok, status, result = {} } = res || {};
	if (status === 200) {
		console.log('getRedisKey...', res);
		// yield put({ type: ACITONCOPYRIGHT.SET_UPLOAD_TOKENINFO, payload: result.data });
		return callback && callback(result);
	}
	return errorCallback && errorCallback(result);
}

let crUploadSaga = [
	takeLatest(ACITONCOPYRIGHT.FETCH_COPYRIGHT_IMGINFO, uploadImgInfo),
	takeLatest(ACITONCOPYRIGHT.FETCH_UPLOAD_TOKEN, getUploadToken),
	takeLatest(ACITONCOPYRIGHT.FETCH_UPLOAD_REDISKEY, getRedisKey)
];
export { crUploadSaga };
